import { Collapse, Modal } from 'antd';
import { ModalFuncProps } from 'antd/lib/modal';
import i18n from 'i18n';
import React from 'react';

interface IProps extends ModalFuncProps {
  type: 'warning' | 'error' | 'info';
  titleText?: string;
  content?: string;
  details?: string;
  destroyOthers?: boolean; // if clear other modals
}

const ModalFunction = {
  warning: Modal.warning,
  error: Modal.error,
  info: Modal.info,
};

export const getTransDetail = (detail: any) => {
  let details = '';
  try {
    if (detail) {
      for (const key in detail) {
        if (detail.hasOwnProperty(key)) {
          details += `[${key}]: ${detail[key]} <br />`;
        }
      }
    }
  } catch (e) {
    console.log('error: get trans details', e);
    details = '';
  }
  return details;
};

export const DetailedModal = (props: IProps) => {
  const { type, details, content, destroyOthers, title, titleText, ...rest } = props;
  console.log('modal details', details);
  destroyOthers && Modal.destroyAll();
  ModalFunction[type]({
    className: 'modal-detail',
    title: titleText ? <div dangerouslySetInnerHTML={{ __html: titleText }}></div> : title,
    content: (
      <div>
        {content && (
          <div
            className="detailed-modal-content"
            dangerouslySetInnerHTML={{ __html: content }}
          ></div>
        )}
        {details && (
          <Collapse>
            <Collapse.Panel header={i18n.t('common.details')} key="1">
              <div dangerouslySetInnerHTML={{ __html: details }}></div>
            </Collapse.Panel>
          </Collapse>
        )}
      </div>
    ),
    ...rest,
  });
};
